<template>
    <div class="overlay">
      <div class="modal-wrapper p-4 bg-white rounded shadow">
        <portlet :actionsBlock="true">
          <template #portletBody>
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <h4 class="mb-5 title">Do you want to accept this chat?</h4>
                        </div>
                        <div class="row"> 
                          <span class="modal-text subtitle mr-2">From: </span>
                          <span class="modal-text">{{ notification.owner.name }}</span>
                        </div>
                        <div class="row">
                          <span class="modal-text subtitle">Message:</span>
                        </div>
                        <div class="row">
                          <span class="modal-text mb-5">{{ notification.message }}</span>
                        </div>
                        <div class="row d-flex justify-content-center mb-4">
                            <button
                                class="btn btn-primary"
                                @click="onAccept"
                            >
                                Accept
                            </button>
                        </div>
                        <div class="row d-flex justify-content-center">
                            <span>OR</span>
                        </div>
                        <div class="row d-flex justify-content-center mt-4">
                            <button class="btn btn-secondary" @click="onIgnore">
                                Decline
                            </button>
                        </div>
                    </div>
                </div>
            </div>
          </template>
        </portlet>
        <button class="close-btn" @click="$emit('close')">&times;</button>
      </div>
    </div>
  </template>
  
  <script>
  import { RIGHTS } from '../../../views/roles/rights.js'
  
  export default {
    name: 'AcceptTransferModal',
    props: {
      notification: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
      }
    },
    async created() {
      this.rights = RIGHTS;
      console.log(this.notification);
    },
    methods: {
        onIgnore() {
            this.$emit('ignoreAcceptTransfer')
            this.$emit('close')
        },
        onAccept() {
            this.$emit('confirmAcceptTransfer')
            this.$emit('close')
        }
    }
  }
  </script>
  
  <style scoped>
    .overlay {
      position: fixed;
      top:0; left:0;
      width:100%; height:100%;
      background: rgba(0,0,0,0.5);
      display:flex;
      align-items:center;
      justify-content:center;
      z-index:1050;
    }
    .modal-wrapper {
      position:relative;
      width: 400px;
      max-width: 95%;
      background: #fff;
    }
    .title {
      color: #146F70;
      font-weight: 600;
    }
    .modal-text {
      font-size: 1.5rem;
      font-weight: 600;
    }
    .subtitle {
      color: #FF924E;
    }
    .btn {
      border-radius: 10px;
      width: 100%;
    }
    .modal-wrapper .btn-primary {
      background-color: #FF924E;
      border: none;
    }
    .modal-wrapper .btn-secondary {
      background-color: #146F70;
      border: none;
    }
    .modal-wrapper .btn-primary:hover {
      background-color: #E58346;
    }
    .modal-wrapper .btn-secondary:hover {
      background-color: #126465;
    }
    .close-btn {
      position:absolute;
      top:1.5rem; 
      right:2rem;
      background:transparent;
      border:none;
      font-size:2.5rem;
      color:#333;
      cursor:pointer;
    }
    .user-list {
      max-height: 200px;
      overflow-y: auto;
    }
    ::v-deep .m-portlet__head {
      display: none
    }
  </style>
  